module.exports = __webpack_public_path__ + "odinstatic/v13.0.1/media/pricing.9d77b4b6.svg";